import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = {
  // Newsletter
  subscribeNewsletter: async (email) => {
    const response = await axios.post(`${API}/newsletter/subscribe`, { email });
    return response.data;
  },

  // Investors
  registerInvestor: async (data) => {
    const response = await axios.post(`${API}/investors/register`, data);
    return response.data;
  },

  // Contact
  sendContactMessage: async (data) => {
    const response = await axios.post(`${API}/contact`, data);
    return response.data;
  },

  // Stats
  getStats: async () => {
    const response = await axios.get(`${API}/stats`);
    return response.data;
  },

  // Analytics
  trackClick: async (data) => {
    try {
      const response = await axios.post(`${API}/analytics/click`, {
        ...data,
        user_agent: navigator.userAgent,
        page_url: window.location.href
      });
      return response.data;
    } catch (error) {
      // Silently fail - analytics shouldn't break the user experience
      console.error('Analytics tracking failed:', error);
      return null;
    }
  },

  getAnalyticsSummary: async () => {
    const response = await axios.get(`${API}/analytics/clicks/summary`);
    return response.data;
  },

  getAnalyticsClicks: async () => {
    const response = await axios.get(`${API}/analytics/clicks`);
    return response.data;
  },
};

export default api;